import template from './sw-cms-block-top-finder-selectboxes.html.twig';
import './sw-cms-block-top-finder-selectboxes.scss';

Shopware.Component.register('sw-cms-block-top-finder-selectboxes', {
    template
});